import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import UserProfile from './user-profile';
import Dependents from './Dependents';
import HippaPatientRight from './HippaPatientRight';
import useProfile from './hooks/useProfile';
import EditMemberContactInfo from './user-profile/EditMemberContactInfo';
import EditMemberRegisteredEmail from './user-profile/EditMemberRegisteredEmail';
import MasterPermissions from '../../../api/MasterPermissions';
import {
  getMemberUserAndMemberDetails,
  getMemberUserData,
} from 'src/redux/admin/api-calls/members';
import { useDispatch } from 'react-redux';
import { EOBPreferences } from './eob-preferences/EOBPreferences';

const Profile = ({ memberType, coverageFor }) => {
  const dispatch = useDispatch();
  const [showEditMemberContactDetails, setShowEditMemberContactDetails] =
    useState(false);
  const [showEditDependentContactDetails, setShowEditDependentContactDetails] =
    useState(false);

  const [timestamp, setTimestamp] = useState(Date.now());

  const {
    loader,
    defaultTab,
    viewUserProfile,
    viewDependent,
    viewHippaRights,
    employeeInfo,
    employmentDetails,
    PhoneEmailInfo,
    residentialAddress,
    mailingAddress,
    selectedMember,
    dependentsData,
    fetchDependentsData,
    allowEmpViewMyInfo,
    allowRespPartyViewMyInfo,
    responsiblePartyInfo,
    serverError,
    serverErrorHipaa,
    activeDependentId,
    fetchEmployeeData,
    eobPreferences,
    setEobPreferences,
  } = useProfile();

  useEffect(() => {
    setShowEditMemberContactDetails(false);
    setShowEditDependentContactDetails(false);
  }, [selectedMember, selectedMember?.ID]);

  const MemberEditPermissions = {
    viewProfile: MasterPermissions.CheckPermission(
      'View Self Profile Information',
    ),
    editContact: MasterPermissions.CheckPermission(
      'Edit Member Contact Information',
    ),
    editAddress: MasterPermissions.CheckPermission(
      'Edit Member Address Information',
    ),
    alternateEmail: MasterPermissions.CheckPermission('Alternate Email'),
    primaryEmail: MasterPermissions.CheckPermission('Primary Email'),
    editPrimaryEmail: MasterPermissions.CheckPermission('Edit Primary Email'),
    editAlternateEmail: MasterPermissions.CheckPermission(
      'Edit Alternate Email',
    ),
  };

  console.log(
    '***** >>>>> MemberEditPermissions',
    MemberEditPermissions,
    viewDependent,
    dependentsData,
  );

  const DependentEditPermissions = {
    viewProfile: MasterPermissions.CheckPermission(
      'View Dependent Profile Information',
    ),
    editContact: MasterPermissions.CheckPermission(
      'Edit Dependent Contact Information',
    ),
    editAddress: MasterPermissions.CheckPermission(
      'Edit Dependent Address Information',
    ),
    alternateEmail: MasterPermissions.CheckPermission('Alternate Email'),
    primaryEmail: MasterPermissions.CheckPermission('Primary Email'),
    editPrimaryEmail: MasterPermissions.CheckPermission('Edit Primary Email'),
    editAlternateEmail: MasterPermissions.CheckPermission(
      'Edit Alternate Email',
    ),
  };
  console.log(
    DependentEditPermissions,
    MemberEditPermissions,
    'MemberEditPermissions',
  );

  //get data and update in redux
  const refreshMemberDataInRedux = () => {
    console.log('*********************************************', employeeInfo);
    //getMemberUserAndMemberDetails(PhoneEmailInfo.Email1);
    dispatch(getMemberUserData({ email: PhoneEmailInfo.Email1 }));
  };

  return (
    <div className="container-offset">
      <Container fluid className="claims-details">
        <Row>
          <Col>
            <Tabs
              defaultTab={defaultTab}
              vertical
              onChange={() => {
                setShowEditMemberContactDetails(false);
                setShowEditDependentContactDetails(false);
              }}
            >
              <TabList>
                {viewUserProfile && (
                  <Tab tabFor="user-profile" role="navigation">
                    User Profile
                  </Tab>
                )}
                {viewDependent && selectedMember.mType === 'Employee' && (
                  <Tab tabFor="dependents" role="navigation">
                    Dependents
                  </Tab>
                )}
                {/*{viewDependent && selectedMember.mType === 'Employee' && (*/}
                {MemberEditPermissions.editPrimaryEmail &&
                  selectedMember.mType === 'Employee' && (
                    <Tab tabFor="registered-email" role="navigation">
                      Registered Email
                    </Tab>
                  )}
                {viewHippaRights && (
                  <Tab tabFor="hippa-patient-right" role="navigation">
                    HIPAA Patient Right
                  </Tab>
                )}

                <Tab tabFor="eob-preferences" role="navigation">
                  EOB Preferences
                </Tab>
              </TabList>
              {!showEditMemberContactDetails &&
              !showEditDependentContactDetails ? (
                <>
                  {viewUserProfile && (
                    <TabPanel tabId="user-profile" className="personal-info">
                      {MasterPermissions.CheckPermission(
                        'View Self Profile Information',
                      ) && (
                        <UserProfile
                          loader={loader}
                          employeeInfo={employeeInfo}
                          loggedInMemberType={selectedMember.mType}
                          loggedInUserOID={selectedMember.ID}
                          residentialAddress={residentialAddress}
                          mailingAddress={mailingAddress}
                          PhoneEmailInfo={PhoneEmailInfo}
                          employmentDetails={employmentDetails}
                          serverError={serverError}
                          onClickEdit={() => {
                            setShowEditMemberContactDetails(true);
                          }}
                        />
                      )}
                    </TabPanel>
                  )}
                  {viewDependent && selectedMember.mType === 'Employee' && (
                    <TabPanel tabId="dependents" className="personal-info">
                      {MasterPermissions.CheckPermission(
                        'View Dependent Profile Information',
                      ) && (
                        <Dependents
                          dependentsData={dependentsData}
                          fetchDependentsData={fetchDependentsData}
                          onClickEdit={() => {
                            setShowEditDependentContactDetails(true);
                          }}
                        />
                      )}
                    </TabPanel>
                  )}
                  {viewHippaRights && (
                    <TabPanel
                      tabId="hippa-patient-right"
                      className="personal-info"
                    >
                      <HippaPatientRight
                        allowEmpViewMyInfo={allowEmpViewMyInfo}
                        allowRespPartyViewMyInfo={allowRespPartyViewMyInfo}
                        responsiblePartyInfo={responsiblePartyInfo}
                        serverErrorHipaa={serverErrorHipaa}
                        selectedMember={selectedMember}
                        employeeInfo={employeeInfo}
                      />
                    </TabPanel>
                  )}
                  {
                    <TabPanel
                      tabId="registered-email"
                      className="personal-info"
                    >
                      {!loader ? (
                        <EditMemberRegisteredEmail
                          data={{
                            viewUserProfile,
                            viewDependent,
                            viewHippaRights,
                            employeeInfo,
                            employmentDetails,
                            PhoneEmailInfo,
                            residentialAddress,
                            mailingAddress,
                            selectedMember,
                            dependentsData,
                            serverError,
                            loader,
                            activeDependentId,
                            fetchDependentsData,
                          }}
                          isMemberSelected={
                            showEditMemberContactDetails === true
                          }
                          isDependentSelected={
                            showEditDependentContactDetails === true
                          }
                          onCancel={() => {
                            setShowEditMemberContactDetails(false);
                            setShowEditDependentContactDetails(false);
                          }}
                          onSuccessfulSubmit={() => {
                            setTimestamp(Date.now());
                            fetchDependentsData();
                            fetchEmployeeData();
                            setShowEditMemberContactDetails(false);
                            setShowEditDependentContactDetails(false);
                            refreshMemberDataInRedux();
                          }}
                          timestamp={timestamp}
                          MemberEditPermissions={MemberEditPermissions}
                          DependentEditPermissions={DependentEditPermissions}
                          memberType={memberType}
                        />
                      ) : (
                        false
                      )}
                    </TabPanel>
                  }
                  <TabPanel tabId="eob-preferences" className="">
                    <EOBPreferences
                      eobPreferences={eobPreferences}
                      setEobPreferences={setEobPreferences}
                      dataFetching={loader}
                      selectedMemberType={selectedMember.mType}
                      selectedMemberOID={selectedMember.ID}
                      coverageFor={coverageFor}
                    />
                  </TabPanel>
                </>
              ) : (
                <TabPanel
                  tabId={
                    showEditMemberContactDetails ? 'user-profile' : 'dependents'
                  }
                  className="personal-info"
                >
                  <EditMemberContactInfo
                    data={{
                      viewUserProfile,
                      viewDependent,
                      viewHippaRights,
                      employeeInfo,
                      employmentDetails,
                      PhoneEmailInfo,
                      residentialAddress,
                      mailingAddress,
                      selectedMember,
                      dependentsData,
                      serverError,
                      loader,
                      activeDependentId,
                      fetchDependentsData,
                    }}
                    isMemberSelected={showEditMemberContactDetails === true}
                    isDependentSelected={
                      showEditDependentContactDetails === true
                    }
                    onCancel={() => {
                      setShowEditMemberContactDetails(false);
                      setShowEditDependentContactDetails(false);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                    onSuccessfulSubmit={() => {
                      setTimestamp(Date.now());
                      fetchDependentsData();
                      fetchEmployeeData();
                      setShowEditMemberContactDetails(false);
                      setShowEditDependentContactDetails(false);
                      refreshMemberDataInRedux();
                    }}
                    timestamp={timestamp}
                    MemberEditPermissions={MemberEditPermissions}
                    DependentEditPermissions={DependentEditPermissions}
                  />
                </TabPanel>
              )}
            </Tabs>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Profile;
